<template>
  <div class="sorted">
    <h1 class="title">Posts Sorted</h1>
    <div class="posts-box">
      <el-skeleton :loading="isLoading" :rows="10" animated>
        <el-timeline>
          <!-- <el-timeline-item class="item" timestamp="2021-05-15" placement="top" size="large" type="primary">
            <p class="p"><a href="#">Spring Boot 项目搭建步骤</a><span class="time">18:56</span></p>
            <p class="p"><a href="#">Spring Boot 整合 Mybatis Plus</a><span class="time">18:56</span></p>
            <p class="p"><a href="#">Redis学习笔记</a><span class="time">18:56</span></p>
          </el-timeline-item> -->
          <el-timeline-item :key="group.id" v-for="group in groups" class="item" :timestamp="fDatetime2FromNowStr(group.date)" placement="top" size="large">
            <p class="p" :key="b.id" v-for="b in group.blogs"><a :href="`/blog/${b.id}`">{{b.title}}</a><span class="time">{{fDatetime2Time(b.gmtCreate)}}</span></p>
          </el-timeline-item>
        </el-timeline>
      </el-skeleton>
    </div>
  </div>
</template>

<script lang="ts">
import { useGetRequest } from '@/hooks'
import { AssertGoodResponse } from '@/util/GlobalUtil'
import { defineComponent, reactive, toRefs } from 'vue'
import { fDatetime2Time, fDatetime2FromNowStr } from '@/filters'

export default defineComponent({
  setup() {
    const state = reactive({
      isLoading: true,
      groups: [],
    })

    useGetRequest('/api/blog/groups_by_day').then((res) => {
      AssertGoodResponse(res)
      state.groups = res.data.data
      state.isLoading = false
    })

    return {
      ...toRefs(state),
      fDatetime2Time,
      fDatetime2FromNowStr,
    }
  },
})
</script>

<style lang="scss" scoped>
.sorted {
  .posts-box {
    margin-top: 30px;
    .item {
      color: $theme-color;

      .p {
        $p-height: 35px;
        height: $p-height;
        line-height: $p-height;
        position: relative;
        cursor: pointer;
        transition: color 0.5s;
        transition: transform 0.5s;
        color: black;

        .time {
          position: absolute;
          right: 0;
          top: 0;
        }

        a {
          font-size: 1rem;
          display: block;
          color: inherit;
          text-decoration: none;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        &:hover {
          color: $theme-color;
          transform: translateX(10px);
        }
      }
    }
  }
}
</style>